import { css } from '@leafygreen-ui/emotion';

export const paddingTopStyles = css`
  padding-top: var(--virtual-padding-top, '0px');
`;

export const paddingBottomStyles = css`
  padding-bottom: var(--virtual-padding-bottom, '0px');
`;
